import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IFaIcon } from 'src/app/api/modules/icons/fa/IFaIcon';
import { FaIconComponent } from 'src/app/modules/icons/components/fa-icon/fa-icon.component';
import { MediaRepository } from '../media.repository';

/**
 * The Media UI.
 *
 * It is not standalone and belongs within the {@link MediaComponent}.
 */
@Component({
  selector: 'app-media-ui',
  templateUrl: './media-ui.component.html',
  styleUrls: ['./media-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
})
export class MediaUIComponent {
  protected readonly mediaRepository = inject(MediaRepository);

  /** Play button icon configuration */
  readonly playIcon: IFaIcon = {
    name: 'fas:circle-play',
    color: 'white',
  };

  /** Pause icon configuration */
  readonly pauseIcon: IFaIcon = {
    name: 'fas:circle-pause',
    color: 'white',
  };
}
